"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ui = require("@retisio/ui");
var _sidenavModule = _interopRequireDefault(require("./sidenav.module.scss"));
var _rbac = require("@retisio/rbac");
var _common = _interopRequireDefault(require("./common.helper"));
var _simplebarReact = _interopRequireDefault(require("simplebar-react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ArcSideNavigation(props) {
  var options = props.options,
    appId = props.appId,
    className = props.className,
    _onClick = props.onClick;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    menuData = _useState2[0],
    setMenuData = _useState2[1];
  var pathname = window.location.pathname;
  var _useContext = (0, _react.useContext)(_rbac.AuthContext),
    user = _useContext.user;
  (0, _react.useEffect)(function () {
    if (user.permissionIds) {
      var sideMenuData = (0, _common["default"])(options, user);
      setMenuData(sideMenuData);
    }
  }, [user]);
  return /*#__PURE__*/_react["default"].createElement(_simplebarReact["default"], {
    style: {
      maxHeight: "calc(100vh - 60px)"
    },
    className: "".concat(_sidenavModule["default"].wrapper, " ").concat(className ? className : '')
  }, /*#__PURE__*/_react["default"].createElement("ul", null, menuData.map(function (menu, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(pathname.indexOf(menu.href) > -1 || i === 0 && pathname === appId ? _sidenavModule["default"].activeMenu : _sidenavModule["default"].menuList),
      key: menu.href
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(pathname.indexOf(menu.href) > -1 || i === 0 && pathname === appId ? _sidenavModule["default"].activeItem : "")
    }), /*#__PURE__*/_react["default"].createElement("li", null, menu.href !== 'orders' ? /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        return _onClick(menu.href);
      },
      className: _sidenavModule["default"].aTag
    }, /*#__PURE__*/_react["default"].createElement(_ui.ArcIcon, {
      name: menu.icon,
      size: {
        width: 24,
        height: 24
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, menu.title)) : /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick() {
        return _onClick(menu.href);
      },
      className: _sidenavModule["default"].aTag
    }, /*#__PURE__*/_react["default"].createElement(_ui.ArcIcon, {
      name: menu.icon,
      size: {
        width: 24,
        height: 24
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, menu.title))));
  })));
}
var _default = ArcSideNavigation;
exports["default"] = _default;